import {
  getTestAverage,
  getScheuledTests,
  getAttemptedTests,
  updateTestStatus,
  testPaperForStudent,
  getStudentTestPaper,
  saveAnswer,
  submitTestPaper,
  answeredTestPaper,
  reportQuestion,
  addAssignment
} from './api'
import { assessmentSlice } from './reducer'

const { updateError, updateAnswerForQuestion, updateMarkForReview,updateStatus } =
  assessmentSlice.actions

export {
  getTestAverage,
  updateError,
  getScheuledTests,
  getAttemptedTests,
  updateTestStatus,
  testPaperForStudent,
  getStudentTestPaper,
  updateAnswerForQuestion,
  saveAnswer,
  submitTestPaper,
  updateMarkForReview,
  answeredTestPaper,
  reportQuestion,
  updateStatus,
  addAssignment
}
